import axios from 'axios';

//produccion
// const URL_BASE = 'https://harmony-production-ff6ebeae2992.herokuapp.com/'; // anterior ya no fucniona
// const URL_BASE = 'https://harmony-api-prod-4a08fe78d33b.herokuapp.com/'; // 20-06-2025 //vencida porque se elimino heroku por falta de pago
const URL_BASE = 'https://harmony-api-prod-9e8852c9ba0d.herokuapp.com/'; // 20-06-2025 //vencida porque se elimino heroku por falta de pago

// const URL_BASE = 'http://localhost:3000/'; // 20-06-2025

const HarmonyApi = axios.create({
  baseURL: URL_BASE,
});

export default HarmonyApi;
